import {
  TREATMENT_PATIENT_PORTAL_PATH,
} from "./treatmentUiConstants";

export const buildTreatmentOrdersUrl = (patientPortalDomain) => {
  const domain = String(patientPortalDomain || "").trim();
  if (!domain) return "";
  try {
    const portal = new URL(domain, window.location.origin);
    return new URL(
      TREATMENT_PATIENT_PORTAL_PATH.orders,
      `${portal.origin}/`,
    ).toString();
  } catch (_error) {
    return "";
  }
};
